export class Token {
  accessToken: string;
  refreshToken: string;
  expiration: number;
  id: string;
}
